<section class="process-main">
  <div class="container">
    <div class="process-main-child">
      <div class="process-title">
        <h3>{{ 'PROCESS.TITLE' | translate }}</h3>
        <div class="process-line"></div>
      </div>

      <div class="process-text">
        <div class="just-text">
          <a>{{ 'PROCESS.GUIDE' | translate }}</a>
        </div>

        <ul>
          <li>
            <p>
              1. {{ 'PROCESS.STEP1' | translate }}
              <a routerLink="/create-new">{{
                'PROCESS.CLICK_HERE' | translate
              }}</a
              >.
            </p>
          </li>
          <li>
            <p>2. {{ 'PROCESS.STEP2' | translate }}</p>
          </li>
          <li>
            <p>3. {{ 'PROCESS.STEP3' | translate }}</p>
          </li>
          <li>
            <p>4. {{ 'PROCESS.STEP4' | translate }}</p>
          </li>
          <li>
            <p>5. {{ 'PROCESS.STEP5' | translate }}</p>
          </li>
          <li>
            <p>
              {{ 'PROCESS.NEED_HELP' | translate }}
              <a routerLink="/support">{{ 'PROCESS.HERE' | translate }}</a
              >.
              {{ 'PROCESS.REMINDER' | translate }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
